
















import TableCell from './TableCell.vue'

export default {
  components: {
    TableCell
  },
  props: {
    loadDescription: { type: String, default: null },
    hSpan: { type: Number, default: 4 }
  },
  computed: {
    tooltip() {
      return this.loadDescription && this.loadDescription.length > 60
        ? this.loadDescription
        : ''
    }
  }
}
